"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryCanSendDirectDto = void 0;
class QueryCanSendDirectDto {
    channelName;
    userId;
}
exports.QueryCanSendDirectDto = QueryCanSendDirectDto;
